import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Moment } from 'moment';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth.service';
import { Constants } from '../../const/constants';

@Component({
  selector: 'app-add-carrier-certification',
  templateUrl: './add-carrier-certification.component.html',
  styleUrls: ['./add-carrier-certification.component.css'],
  standalone: false,
})
export class AddCarrierCertificationComponent implements OnDestroy {
  @ViewChild('picker') datePicker: MatDatepicker<null>;
  expirationDate = new Subject<Moment>();
  minimumDate: Date;
  expDate: Date;
  subs: Subscription[] = [];
  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthService,
  ) {
    this.minimumDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
    );
    this.expDate = this.minimumDate;

    this.subs.push(
      this.authService.timeoutStatus.subscribe(isTimeout => {
        if (isTimeout) {
          this.activeModal.dismiss();
          if (this.datePicker) {
            this.datePicker.close();
          }
        }
      }),
    );
  }
  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }
  confirmAction() {
    if (this.expDate != null)
      this.expirationDate.next(
        moment.utc(
          moment(this.expDate).format(Constants.NO_TIMEZONE_DATE_TIME_FORMAT),
        ),
      );
    this.activeModal.dismiss();
  }
}
